<template>
  <div class="container-fluid customPadding">
    <b-row>
      <label class="font-weight-bold ml-3 mt-2">Surveys</label>
    </b-row>
    <b-input
      v-model="filter"
      class="mt-2 mb-2"
      placeholder="Filter surveys..."
      type="search"
    ></b-input>
    <b-table
      id="surveys-table"
      :busy.sync="busy"
      :current-page="currentPage"
      :fields="eventsFields()"
      :filter="filter"
      :items="events"
      :per-page="perPage"
      bordered
      class="rounded-lg text-center"
      empty-filtered-text="There are no surveys matching your filter."
      empty-text="There are no surveys available."
      fixed
      head-variant="dark"
      hover
      primary-key="Id"
      responsive="sm"
      show-empty
      striped
      table-variant="light"
      @filtered="onFiltered"
    >
      <template #table-caption
        >{{ totalRows }} {{ totalRows === 1 ? 'survey' : 'surveys' }}
      </template>
      <template #table-busy>
        <div class="text-center text-secondary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(actions)="row">
        <b-button class="mr-1" variant="link-dark" @click="action(row.item, 'View All')">
          <b-icon icon="folder"></b-icon>
          View Surveys
        </b-button>
        <b-button class="mr-1" variant="link-dark" @click="action(row.item, 'Create Survey')">
          <b-icon icon="plus-circle"></b-icon>
          Create/Edit Survey
        </b-button>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :per-page="perPage"
      :total-rows="totalRows"
      align="center"
      aria-controls="surveys-table"
      pills
    ></b-pagination>
  </div>
</template>
<script>
  import tableFieldsMixin from '../mixins/tableFieldsMixin';

  export default {
    mixins: [tableFieldsMixin],
    metaInfo() {
      let metaTitle = this.$appName + 'Surveys';
      return {
        title: metaTitle,
      };
    },
    data() {
      return {
        busy: false,
        events: [],
        filter: '',
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
      };
    },
    created() {
      this.getEvents();
    },
    methods: {
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async getEvents() {
        try {
          this.busy = true;
          let response = await axios.get(`/api/get-person-events`);
          if (response.data['records'] != null) {
            this.events = response.data['records'];
            this.totalRows = this.events.length;
          }
        } catch (error) {
          console.error(error);
          alert(`Server is not responding, please try again later`);
        }
        this.busy = false;
      },
      action(event, action) {
        let name = 'create-person-survey';
        if (action === 'View All') {
          name = 'view-person-surveys';
        }
        this.$router.push({
          name: name,
          params: { eventId: event['Id'] },
        });
      },
    },
  };
</script>
